import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const useMenuSettings = () => {
  const [config, setConfig] = useState({ module_visibility: {}, role_access: {}, custom_roles: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/menu-config`, { withCredentials: true });
        if (mounted && res.data) setConfig({ module_visibility: {}, role_access: {}, custom_roles: [], ...res.data });
      } catch (e) {
        /* default: tampilkan semua */
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return { ...config, loading };
};
